var date = {
  "abbr_day_names": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  "abbr_month_names": [null, "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  "day_names": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  "formats": {
    "default": "%d/%m/%Y",
    "long": "%e. %B %Y",
    "short": "%e. %b",
    "datepicker2": "%d %b %Y",
    "short_day": "%a %e %b",
    "month_year": "%b %Y",
    "day_only": "%d",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "graph": {
      "long": "%a %e %b %Y",
      "x_axis": {
        "day": "%e-%b",
        "week": "%e-%b"
      }
    },
    "jquery": {
      "datepicker": "d/m/y",
      "datepicker2": "d M yy",
      "power_playback": "ddd d MMM yyyy HH:mm",
      "myenlighten": "dd/mm/yyyy",
      "datejs_formatter": "dd/M/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D, d. M yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a %e %b %Y",
      "short_month_day": "%e&nbsp;%B&nbsp;%Y",
      "short_month_day_time": "%e %B %Y – %H:%M"
    }
  },
  "month_names": [null, "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  "order": ["day", "month", "year"],
  "range": {
    "presets": {
      "today": "Heute",
      "last7Days": "Letzte 7 tage",
      "monthToDate": "Monat bis heute",
      "yearToDate": "Jahr bis heute"
    }
  }
};
module.exports = date;